<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('containerClasses'))">
      <div
        :contenteditable="! previewMode"
        :class="elementClasses(classes('classes'), classes('customClasses'))"
        :style="elementStyles(styles('styles'))"
        v-text="content.text"
        @input="updateContentProperty('text', $event.target.textContent)"
      ></div>
    </div>
  </div>
</template>

<script>
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({})
</script>